import { create } from 'zustand';

interface DashboardState {
  activeTab: number;

  setActiveTab: (activeTab: number) => void;
}

export const useDashboardStore = create<DashboardState>((set) => ({
  activeTab: 0,

  setActiveTab: (activeTab: number) => set({ activeTab }),
}));
